import { client } from "src/services/client";
import { formatTargetDate } from "src/utils/helpers";
import { CondoQuery } from "./types";

// `/condo` returns an empty page if `isExclusive=false` is sent.
// "All listings" means omit the param; keep exclusive=true for that filter.
export const sanitizeCondoFilters = (filters: string) => {
    const params = new URLSearchParams(filters);
    if (params.get("isExclusive") !== "true") {
        params.delete("isExclusive");
    }
    return params.toString();
};

export const fetchCondo = async (query: CondoQuery) =>
    client({
        method: "get",
        url: `/condo?${sanitizeCondoFilters(query.filters)}${
            query.isSold ? `&active=false&closingDate=gte:${formatTargetDate(-180)}` : ""
        }`,
        headers: { "Content-Type": "application/json" },
    }).then((response) => response.data);
